import styles from './ListDrawerToolbar.module.css';

import searchIcon from '../../../assets/svg/serch-01.svg';
import arrowIcon from 'assets/svg/arrow-01.svg';
import refreshIcon from 'assets/svg/refresh-01.svg';

import { useEffect, useRef, useState } from 'react';
import Icon from 'helpers/components/Icon';
import { useListDrawerContext } from '../ListDrawerProvider';
import classNames from 'classnames';
import RegularButton from '../../../ui/RegularButton';
import IconButton from '../../../ui/IconButton';
import { useDebounce } from 'hooks/useDebounce';

const ListDrawerToolbar = () => {
  const { actions, update, search, setSearch, disabled } = useListDrawerContext();

  const [searchValue, setSearchValue] = useState('');
  const debouncedSearch = useDebounce(searchValue, 300);

  const [openAddingMenu, setOpenAddingMenu] = useState(false);

  const addingMenuRef = useRef(null);

  useEffect(() => {
    setSearch(debouncedSearch);
  }, [debouncedSearch]);

  const handleClickOutside = (event) => {
    if (addingMenuRef.current && !addingMenuRef.current.contains(event.target)) {
      setOpenAddingMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.toolBar}>
      <div className={styles.defaultActions}>
        <div className={styles.searchInputContainer}>
          <img className={styles.searchIcon} src={searchIcon} alt={'search'} />
          <input
            className={styles.searchInput}
            placeholder={'Отобрать'}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
        {actions.length > 0 && (
          <div className={styles.addingMenu} ref={addingMenuRef}>
            <RegularButton
              disabled={disabled}
              className={classNames(styles.addButton)}
              text={'Добавить'}
              variant={'flat'}
              onClick={() => {
                setOpenAddingMenu(!openAddingMenu);
              }}
              appendIcon={
                <Icon
                  className={classNames(styles.addIcon, {
                    [styles.openedAddingMenu]: openAddingMenu,
                  })}
                  color={'white'}
                  src={arrowIcon}
                  width={'14px'}
                  height={'14px'}
                />
              }
            />
            <div
              className={styles.addingMenuContainer}
              style={{ display: openAddingMenu ? 'block' : 'none' }}
            >
              {actions.map((item, index) => (
                <div
                  key={index}
                  className={styles.addingMenuItem}
                  onClick={() => {
                    setOpenAddingMenu(!openAddingMenu);
                    item.callback();
                  }}
                >
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        )}
        <IconButton
          tooltip={'Обновить'}
          variant={'flat'}
          disabled={disabled}
          icon={refreshIcon}
          onClick={() => {
            update({ search: search ? search : undefined });
          }}
        />
      </div>
    </div>
  );
};

export default ListDrawerToolbar;
